import axios from 'axios';
import { baseURL } from './api';

const path = process.env.REACT_APP_BASE_URL + '/api/v2';

class VmailService {
  static baseURL = baseURL;

  static resourcePath = path || '';

  constructor(api, demo = false, baseURLOverride) {
    this.api = api;
    this.demo = demo;
    this.baseURL = baseURLOverride;
  }

  getBaseURL = () => {
    return this.baseURL || VmailService.resourcePath || VmailService.baseURL;
  };

  getPaginateOptions = options => {
    return JSON.stringify(options || { page: 1, limit: 10 });
  };

  async getAllVmails(paginateOptions, date = ['', ''], getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}/voicemails/?paginateOptions=${options}&from=${date[1]}&to=${
        date[0]
      }&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async getVmailByCompany(id, paginateOptions, date = ['', ''], getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}/companies/${id}/voicemails?paginateOptions=${options}&from=${
        date[1]
      }&to=${date[0]}&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async getVmailsByUser(id, paginateOptions, date = ['', ''], getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}/users/${id}/voicemails?paginateOptions=${options}&from=${date[1]}&to=${
        date[0]
      }&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  vmailPlayer(token, id) {
    const baseURL = this.getBaseURL();
    return `${baseURL}/voicemails/${id}/download.wav?token=${token}`;
  }

  async deleteVMail(id, hardDelete = global.deleteMode ? 'yes' : 'no') {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.delete(
      `${this.getBaseURL()}/voicemails/${id}?hardDelete=${hardDelete}`,
      {
        headers,
      },
    );
    return data;
  }

  async onRecover(vmailId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const data = await axios.patch(
      `${baseURL}/voiceMails/${vmailId}`,
      {
        deleted: false,
      },
      { headers },
    );
    return data;
  }
}
export default VmailService;
